/**
 * Created by razial on 25.08.2024.
 */

const DiscordSocial = function () {
    Social.call(this, connector.DISCORD, {
        sdk: SdkManager.SDK_DISCORD
    });
};

DiscordSocial.prototype = Object.create(Social.prototype);
DiscordSocial.prototype.constructor = DiscordSocial;

DiscordSocial.prototype._connect = function (callback) {
    this.authorize(() => {
        callback(connector.STATUS_CONNECTED);
    });
};

DiscordSocial.prototype._login = function (callback) {
    this.authorize(callback);
};

DiscordSocial.prototype.authorize = function (callback) {
    discordSdk.commands.authorize({
        client_id: connector.config.discord.appId,
        response_type: "code",
        state: "",
        prompt: "none",
        scope: ["identify", "guilds", "applications.commands", "relationships.read"]
    }).then((result) => {
        ConnectorRestClient.post("/discord/token", { code: result.code }, (data) => {
            discordSdk.commands.authenticate({
                access_token: data.access_token
            }).then((result) => {
                if (result && result.user && result.user.id) {
                    this.accessToken = data.access_token;
                    this.user = DiscordSocial.formatUserData(result.user);

                    callback();
                    return;
                }

                console.log("[connector] discord authentication rejected");
                callback();
            }).catch((error) => {
                console.log("[connector] discord authentication failed", error);
                callback();
            });
        }, (response) => {
            console.log("[connector] can't load discord access token", response.status, response.errorMessage);
            callback();
        });
    }).catch((error) => {
        console.log("[connector] discord authorization failed", error);
        callback();
    });
};

DiscordSocial.prototype.getAccessToken = function () {
    return `DISCORD_${this.accessToken}`;
};

DiscordSocial.prototype.isLoggedIn = function () {
    return Boolean(this.user) && Boolean(this.accessToken);
};

DiscordSocial.prototype._getUserID = function () {
    return this.user && this.user.id;
};

DiscordSocial.prototype._aboutMe = function (callback) {
    if (this.user) {
        callback(connector.CODE_SUCCEED, this.user);
    } else {
        callback(connector.CODE_FAILED);
    }
};

DiscordSocial.prototype.isInviteSupported = function () {
    return true;
};

DiscordSocial.prototype.isSupportsNativeRequest = function () {
    return true;
};

DiscordSocial.prototype.invite = function (data, callback) {
    discordSdk.commands.openInviteDialog().then(() => {
        callback(connector.CODE_SUCCEED);
    }).catch(() => {
        callback(connector.CODE_FAILED);
    });
};

DiscordSocial.prototype._listFriends = function (callback) {
    discordSdk.commands.getRelationships().then((result) => {
        if (!result || !result.relationships) {
            callback(connector.CODE_FAILED);
            return;
        }

        const friends = result.relationships
            .filter((relationship) => relationship.type === DiscordSocial.RELATIONSHIP_TYPE_FRIEND)
            .map((relationship) => {
                const user = relationship.user;
                return DiscordSocial.formatUserData(user);
            });

        callback(connector.CODE_SUCCEED, friends);
    }).catch((error) => {
        console.log("[connector] discord get relationships failed", error);
        callback(connector.CODE_FAILED);
    });
};

DiscordSocial.prototype.request = function (data, callback) {
    if (!data.to || !Array.isArray(data.to) || data.to.length === 0 || !data || !data.text) {
        callback(connector.CODE_FAILED);
        return;
    }

    discordSdk.commands.shareLink({
        message: data.text
    }).then((result) => {
        const success = result.success;
        if (success) {
            callback(connector.CODE_SUCCEED, data.to);
        } else {
            console.log("[connector] discord share link cancelled");
            callback(connector.CODE_CANCELLED);
        }
    }).catch((error) => {
        console.log("[connector] discord share link error", error);
        callback(connector.CODE_FAILED);
    });
};

DiscordSocial.formatUserData = function (user) {
    // user: {
    //     avatar: null
    //     discriminator: "0"
    //     global_name: "Full User Name"
    //     id: "399150507756617730"
    //     public_flags: 0
    //     username: "r4zi4l"
    // }

    const userid = `${user.id}`;
    let avatar = user.avatar;
    let name = user.global_name;

    if (!name) {
        name = `${user.username}#${user.discriminator}`;
    }

    if (avatar) {
        avatar = `https://cdn.discordapp.com/avatars/${userid}/${avatar}.png?size=256`;
    } else {
        avatar = `https://cdn.discordapp.com/embed/avatars/${parseInt(userid.slice(-7)) % 6}.png`;
    }

    return {
        id: userid,
        name,
        avatar
    };
};
DiscordSocial.RELATIONSHIP_TYPE_FRIEND = 1;